module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Angus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The first woman to row across the Atlantic Ocean from mainland to mainland, "), _c('B', [_vm._v("Julie Angus")]), _vm._v(" has also cycled across continents, rowed thousands of kilometers of coastlines and rivers, and organized an expedition that sailed the ancient Phoenician trading routes. The author of "), _c('I', [_vm._v("Rowboat in a Hurricane,")]), _vm._v(" she lives in Comox, British Columbia.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4JPgEd/tc-custom/9781771000062.jpg?1737058339143",
      "alt": "This image is the cover for the book Olive Odyssey"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Olive Odyssey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This Mediterranean travel memoir offers “an engaging mix of history, food travelogue, and botany lesson . . . There is much to enjoy here” ("), _c('i', [_vm._v("Library Journal")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Inspired by her Syrian forebears’ intimate relationship with the olive, Julie Angus embarks on a voyage around the Mediterranean to unlock the secrets of the fruit that meant so much to them. Accompanied by her husband and their ten-month-old son, Angus collects samples from ancient trees to determine where the first olive tree originated; feasts on inky black tapenades and codfish drizzled with olive oil, among many other delights; witnesses the harvesting of olives in Greece; and visits perhaps the oldest olive tree in the world, on Crete. The result is a fascinating history and biography of this most influential and irresistible fruit."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("“It is a pleasure to try to keep up with this book; like its author, it covers an enormous amount of territory.” —Christopher Bakken, "), _c('i', [_vm._v("Wall Street Journal")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Greystone Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0